import React, { memo } from 'react';
import { Gift, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const GiftWishes = () => {
  const navigate = useNavigate();
  const giftOptions = [{
    title: 'Home Essentials',
    description: 'Help us build our new home together with essential items for our journey.',
    icon: <Heart size={24} className="text-gold" data-id="element-77" />,
    path: '/gifts/home-essentials'
  }, {
    title: 'Honeymoon Fund',
    description: 'Contribute to our dream honeymoon and help us create unforgettable memories.',
    icon: <Gift size={24} className="text-gold" data-id="element-78" />,
    path: '/gifts/honeymoon-fund'
  }];
  return <section id="gifts" className="bg-ivory py-20" data-id="element-79">
      <div className="section-container" data-id="element-80">
        <h2 className="section-heading" data-id="element-81">Gifts & Wishes</h2>
        <p className="text-center text-gray-700 max-w-2xl mx-auto mb-10" data-id="element-82">
          Your presence at our wedding is the greatest gift of all. However, if
          you wish to honor us with a gift, we've included some options below.
        </p>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-83">
          {giftOptions.map((option, index) => <div key={index} className="bg-white border border-champagne border-opacity-40 p-8 rounded-md shadow-sm text-center" data-id="element-84">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-blush rounded-full mb-4" data-id="element-85">
                {option.icon}
              </div>
              <h3 className="font-serif text-xl mb-3 text-gray-800" data-id="element-86">
                {option.title}
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-87">{option.description}</p>
              <button onClick={() => navigate(option.path)} className="px-6 py-2 bg-gold text-white hover:bg-opacity-90 transition-colors duration-300" data-id="element-88">
                View Options
              </button>
            </div>)}
        </div>
      </div>
    </section>;
};
export default GiftWishes;